export const siteInfo = {
  name: '555电影网',
  slogan: '4K电影超清影视免费看',
  description: '555电影网推出4K电影与超清影视专区，4K电视剧高清画质免费在线播放。极致视觉体验，超清画质不缓冲流畅观看，覆盖4K大片、超清剧集等高品质影视资源。',
  domain: 'https://www.555dy.com',
  founded: '2018',
  email: 'contact@555dy.com',
  phone: '400-555-8888',
  address: '北京市朝阳区望京科技园A座',
};

export const aboutContent = {
  intro: [
    {
      title: '关于555电影网',
      content: '555电影网成立于2018年，是国内领先的4K超清影视在线播放平台。我们致力于为影迷提供最优质的观影体验，汇聚海量4K电影、超清电视剧、热门动漫、精品纪录片及综艺节目，让每一位用户都能享受极致视觉盛宴。',
    },
    {
      title: '我们的使命',
      content: '让高品质影视内容触手可及。我们相信，好的故事值得用最好的画质来呈现。555电影网通过不断升级技术，确保每一帧画面都清晰流畅，每一部作品都完美呈现。',
    },
  ],
  features: [
    {
      icon: 'ri-4k-line',
      title: '4K超清画质',
      description: '采用最新的4K编码技术，画面细节纤毫毕现，色彩饱满生动，让您享受影院级的观影体验。',
    },
    {
      icon: 'ri-speed-line',
      title: '流畅不缓冲',
      description: '全球CDN加速节点覆盖，智能码率自适应，即使网络波动也能保证流畅播放，告别卡顿烦恼。',
    },
    {
      icon: 'ri-movie-line',
      title: '海量片库',
      description: '收录超过10万+部影视作品，涵盖电影、电视剧、动漫、综艺、纪录片全品类，每日更新不断。',
    },
    {
      icon: 'ri-device-line',
      title: '多端同步',
      description: '支持电脑、平板、手机多终端无缝切换，观影记录云端同步，随时随地继续您的观影之旅。',
    },
  ],
  stats: [
    { value: '10万+', label: '影视资源' },
    { value: '5000万+', label: '活跃用户' },
    { value: '99.9%', label: '服务可用性' },
    { value: '200+', label: 'CDN节点' },
  ],
  faqs: [
    {
      question: '555电影网的4K视频需要收费吗？',
      answer: '555电影网始终坚持免费观影的理念。我们所有的4K电影、超清影视资源均可免费在线观看，无需支付任何费用，也无需开通会员。我们通过广告收入维持平台运营，为用户提供免费的观影服务。',
    },
    {
      question: '观看4K画质需要什么样的网络条件？',
      answer: '为了流畅观看4K电影，我们建议您的网络带宽不低于25Mbps。不过，555电影网采用了智能码率自适应技术，即使您的网络带宽较低，系统也会自动调整到适合的画质，确保观看不缓冲。',
    },
    {
      question: '555电影网支持哪些设备观看？',
      answer: '555电影网全面支持各种主流设备，包括Windows、Mac电脑、iPhone和Android手机、iPad等平板设备。您只需要使用浏览器访问我们的网站，无需安装任何APP，即可畅享观影体验。',
    },
    {
      question: '电影资源多久更新一次？',
      answer: '我们的内容团队全天候工作，确保最新最热的影视资源第一时间上线。热门大片通常在上映后1-2个月内即可在我们的平台上找到。电视剧和综艺节目坚持每日更新，确保您不错过任何精彩内容。',
    },
    {
      question: '如何在555电影网上找到想看的电影？',
      answer: '您可以通过首页的分类导航、搜索功能，或按电影类型、年份、评分等维度筛选浏览。我们的智能推荐系统还会根据您的观影偏好，为您推荐可能感兴趣的内容。',
    },
  ],
};